export let ChosenAddress = /*#__PURE__*/function (ChosenAddress) {
  ChosenAddress["Normalized"] = "Normalized";
  ChosenAddress["UserInput"] = "UserInput";
  return ChosenAddress;
}({});
export function chosenAddressFromString(str) {
  switch (str) {
    case 'Normalized':
      return ChosenAddress.Normalized;
    case 'UserInput':
      return ChosenAddress.UserInput;
    default:
      return undefined;
  }
}